class DetailsDisclosure extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['details', 'summary']
  }

  setupListeners () {
    super.setupListeners()

    this.close = this.close.bind(this)

    this.onFocusOut = this.onFocusOut.bind(this)
    this.listeners.add(this.els.details.element, 'focusout', this.onFocusOut)
  }

  onFocusOut () {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  close () {
    this.els.details.element.removeAttribute('open')
    this.els.summary.element.setAttribute('aria-expanded', 'false')
  }
}

window.BAO.DetailsDisclosure = DetailsDisclosure

customElements.define('details-disclosure', DetailsDisclosure)
